// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"fbcf4b70","693":"60083cf2","889":"973b1943","917":"753359c4","998":"defb112e"}[chunkId] + ".chunk.css";
};